import { css } from "@emotion/react"
import styled from "@emotion/styled"

import { FlexContainer, FlexContainerAndItem } from "../../../../styled/flexbox.styled"
import { SCIENT_COLORS } from "../../../../styled/scientColors"
import { Side } from "./types/common"

export const TickerListText = styled.p({
  fontSize: "13px",
  margin: "2px 0 0 0",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
})

export const TickerListContainer = styled(FlexContainer)({
  width: "100%",
})

export const SideTickerBlockContainer = styled(FlexContainer)({
  flexDirection: "row",
  alignItems: "flex-start",
  gap: "6px",
  width: "100%",
  flexWrap: "nowrap",
})

export const SideTickerItem = styled(FlexContainerAndItem)({
  flexDirection: "row",
  gap: "10px",
  width: "100%",
  flexWrap: "nowrap",
  overflow: "hidden",
})

export const TagContainer = styled(FlexContainer)({
  width: "80px",
  flexShrink: 0,
})

type StyledTagProps = {
  isWaveDetail?: boolean
  side: Side
}

export const tagCss = ({ isWaveDetail, side }: StyledTagProps) => css`
  background-color: ${side === Side.BUY || side === Side.BUY_COVER
    ? `${SCIENT_COLORS.forest2} !important`
    : `${SCIENT_COLORS.red3} !important`};
  min-width: ${isWaveDetail
    ? side === Side.BUY || side === Side.SELL
      ? "45px !important"
      : "82px !important"
    : side === Side.BUY || side === Side.SELL
      ? "40px !important"
      : "75px !important"};
  text-align: center;
  &.bp5-tag {
    display: inline-table;
  }
`
